<template>
  <div class="mobile-global-toolbar-container">
    <v-toolbar flat density="compact" height="auto">
      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-btn
            :color="selectedToolbar === 'edit' ? 'primary' : null"
            v-bind="props"
            :class="['px-sm-5 px-4 mr-2', { 'accent--text': selectedToolbar !== 'edit' }]"
            @click="toggleSelectedToolbar('edit')"
          >
            Edit
          </v-btn>
        </template>
        <span>Edit</span>
      </v-tooltip>
      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-btn
            :color="selectedToolbar === 'simulation' ? 'primary' : null"
            v-bind="props"
            :class="['px-sm-5 px-4', { 'accent--text': selectedToolbar !== 'simulation' }]"
            @click="toggleSelectedToolbar('simulation')"
          >
            Simulate
          </v-btn>
        </template>
        <span>Simulate</span>
      </v-tooltip>
    </v-toolbar>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { UIEventBus } from "../event-bus";

const selectedToolbar = ref<"simulation" | "edit" | "">("");

function toggleSelectedToolbar(toolbarName: "simulation" | "edit") {
  UIEventBus.emit("toolbarToggled", toolbarName);
  selectedToolbar.value === toolbarName ? (selectedToolbar.value = "") : (selectedToolbar.value = toolbarName);
}
</script>

<style scoped>
.mobile-global-toolbar-container {
  z-index: 1;
}
</style>
